import React from 'react';
import type { FC } from 'react';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { useBiLogger } from '@wix/cli-telemetry-react';
import {
  wixCliLoginStart,
  wixCliLoginEnd,
} from '@wix/bi-logger-dev-tools-data/v2';
import { match } from 'variant';
import { unifiedAuthStrategy } from '../auth-strategies/index.js';
import type { AuthStrategyState } from '../auth-strategies/index.js';

interface Props {
  refreshToken: string;
  onLogin: (data: AuthStrategyState) => void;
  onError: (error: unknown) => void;
}

export const RefreshTokenLogin: FC<Props> = ({
  refreshToken,
  onLogin,
  onError,
}) => {
  const biLogger = useBiLogger();

  const { status } = useAsync(
    async () => {
      void biLogger.report(wixCliLoginStart({}));

      return unifiedAuthStrategy.loginWithRefreshToken({ refreshToken });
    },
    [],
    {
      onSuccess: (authData) => {
        void biLogger.report(
          wixCliLoginEnd({
            isSuccess: true,
          })
        );
        onLogin(authData);
      },
      onError: (error) => {
        void biLogger.report(
          wixCliLoginEnd({
            isSuccess: false,
            ...(error instanceof Error
              ? {
                  errorType: error.name,
                }
              : {
                  errorType: 'unknown',
                  errorMessage: JSON.stringify(error),
                }),
          })
        );

        onError(error);
      },
    }
  );

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner />,
    Success: () => null,
  });
};
